import renderDiv from './render';
import deserializeDiv from './deserialize';

const DivPlugin = options => ({
  renderElement: renderDiv(options),
  deserialize: deserializeDiv(options),
});

export default DivPlugin;
